import React from 'react';
import Head from 'next/head';
import MainContent from 'components/PageInstitutions/MainContent';
import BaseLayout from 'layouts/BaseLayout';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';
import useIsMobile from 'hooks/useIsMobile';
import MainContentMobile from 'components/PageInstitutions/MainContentMobile';

export default function Institutions() {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
      hamburgerMenuActive={false}
    >
      <Head>
        <title>Solutions for Academic Institutions</title>

        <meta
          key="description"
          name="description"
          content=" Inspire new scientific outcomes across your institution with Mind the Graph."
        />
        <meta
          key="og:title"
          name="og:title"
          property="og:title"
          content="Solutions for Academic Institutions"
        />
        <meta
          key="og:description"
          name="og:description"
          property="og:description"
          content=" Inspire new scientific outcomes across your institution with Mind the Graph."
        />
      </Head>

      {!isMobile ? <MainContent /> : <MainContentMobile />}
    </BaseLayout>
  );
}
